import CustomIcon from "./CustomIcon";
import React from "react";
import {IconButton} from "./CustomButton";


const CustomMessage = ({messageType, message, hasCloseButton=false, onClick, hasBackground=true, className, size}) => {
  return <div className={`${messageType === "error" ? "bg-rose-50 border border-rose-100 text-error-500" : messageType === "warning" ? "bg-amber-50 border border-amber-100 text-amber-500" : messageType === "success" ? "bg-emerald-50 border border-emerald-100 text-primary-800" : hasBackground ? "bg-blue-100 border border-blue-200 text-rand-100" : "text-rand-100"} text-sm leading-tight flex justify-between items-center ${hasBackground && "border p-2 "} rounded-md ${className ? className: ""}`}>
    <div className="flex flex-1 items-start">
      <CustomIcon icon={messageType === "error" ? "error" : messageType === "warning" ? "warning" : messageType === "success" ? "check_circle" : "info" } className={`${messageType === "error" ? "text-error-500" : messageType === "warning" ? "text-amber-500" : messageType === "success" ? "text-primary-800" : "text-secondary-500" } mr-2`} size="2xl"/><span className="mt-[3px]">{message}</span>
    </div>
    {hasCloseButton && <IconButton iconColor="text-rand-100" className="bg-transparent ml-2" onClick={onClick}/>}
  </div>
}


export default CustomMessage